import React from "react";
import ReactDOM from "react-dom/client";
import EditorLayout from "./components/EditorLayout";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <EditorLayout />
  </React.StrictMode>
);
